import React from 'react';
import { StockCategoryFilter } from '../../types/stockCategories';
import { MobileMetricCards } from './MobileMetricCards';

interface FinancialMetricsProps {
  // All metric values as a flat map
  metricsMap: Record<string, string | null>;
  // Dynamic group selection from backend
  selectedGroups?: [string, string] | null;
  // Component props
  loading?: boolean;
  className?: string;
  layout?: 'sidebar' | 'mobile-grid' | 'desktop-sidebar';
  visibleHints?: number;
  category?: StockCategoryFilter;
  spotlightStep?: string | null;
  isStreamerMode?: boolean;
}

/**
 * FinancialMetrics component - router that delegates to the unified row-based layout
 */
export const FinancialMetrics: React.FC<FinancialMetricsProps> = ({
  metricsMap,
  selectedGroups,
  loading = false,
  className,
  visibleHints = 0,
  category,
  spotlightStep,
  isStreamerMode
}) => {
  return (
    <MobileMetricCards
      metricsMap={metricsMap}
      selectedGroups={selectedGroups}
      loading={loading}
      className={className}
      visibleHints={visibleHints}
      category={category}
      spotlightStep={spotlightStep}
      isStreamerMode={isStreamerMode}
    />
  );
};

export default FinancialMetrics;
